import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListServiceProduct = createAsyncThunk(
    "serviceProduct/getListServiceProduct",
    async ({ currentPage, pageSize, branchId, search}, { rejectWithValue }) => {
        try {
            let apiUrl = `/api/v1/serviceconnect/service-products?has_paginate&size=${pageSize}&page=${currentPage}`;
            
          if (branchId) {
            apiUrl += `&mcoupon_branch_id=${branchId}`;
          }

          if(search){
            apiUrl += `&search=${search}`;
          }
            const response = await http.get(apiUrl);
            return response.data;
        } catch (error) {
            return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
        }
    }
);